import { Cloud, CloudFog, CloudSnow, Moon, Sun, Wind } from "lucide-react";
import { RainClouds } from "./RainClouds";
import { useWeather, type WeatherKind } from "@/hooks/useWeather";

const KIND_LABEL: Record<WeatherKind, string> = {
  sun: "słonecznie",
  moon: "pogodna noc",
  cloud: "pochmurno",
  rain: "deszcz",
  snow: "śnieg",
  wind: "wietrznie",
  fog: "mgła",
};

function iconFor(kind: WeatherKind, size: number) {
  switch (kind) {
    case "sun":
      return <Sun size={size} />;
    case "moon":
      return <Moon size={size} />;
    case "cloud":
      return <Cloud size={size} />;
    case "snow":
      return <CloudSnow size={size} />;
    case "wind":
      return <Wind size={size} />;
    case "fog":
      return <CloudFog size={size} />;
    case "rain":
      return <RainClouds size={size} />;
    default:
      return <Cloud size={size} />;
  }
}

/**
 * TwoDrive's nav icon, driven by the local weather (resolved client-side via free public
 * APIs — see useWeather). Falls back to RainClouds until/if the weather resolves; the
 * native title shows "city · condition" on hover.
 */
export function WeatherIcon({ size = 16 }: { size?: number }) {
  const { data } = useWeather();
  const kind: WeatherKind = data?.kind ?? "cloud";
  const label = KIND_LABEL[kind];
  const title = data?.city ? `${data.city} · ${label}` : label;
  return (
    <span title={title} className="flex">
      {iconFor(kind, size)}
    </span>
  );
}
